module.exports = __webpack_public_path__ + "img/logo_white.b53da840.png";